import React from "react";
import { IntroWrapper } from "../ui/IntroWrapper";
import { Navigation } from "../components/navigation";
import { Intro } from "../components/intro";
import { Video } from "../components/video";
import { Features } from "../components/features";
import { SearchCard } from "../components/searchCard";
import { Benefits } from "../components/benefits";
import { Testimonial } from "../components/testimonial";
import { DataChart } from "../components/dataChart";
import { FAQ } from "../components/faq";
import { TransformCard } from "../components/transformCard";
import { Footer } from "../components/footer";
import { Pricing } from "../components/pricing";

export const Homepage = () => {
  return (
    <div className="font-sans flex flex-col gap-[100px]">
      <IntroWrapper>
        <Navigation />
        <Intro />
      </IntroWrapper>
      <Video />
      <Features />
      <SearchCard />
      <Benefits />
      <Pricing />
      <Testimonial />
      <DataChart />
      <FAQ />
      <TransformCard />
      <Footer />
    </div>
  );
};
